/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ListItem } from '@trdk/style/List';
import Skeleton from 'react-loading-skeleton';
import {
  Typography,
  withStyles, ListItemText,
  Tabs, Tab, TextField,
  Button, TablePagination,
  Hidden, Grid, List, Divider,
} from '@material-ui/core';
import MuiListItem from '@material-ui/core/ListItem';
import clsx from 'clsx';
import NotificationBar from '@trdk/style/NotificationBar';
import AddParty from '../../../components/add-party';
import Dialog from '../../../components/dialog';
import {
  fetchCommittees, putCommittee,
  postActivateCommittee, postRemoveCommittee,
  postSyncElements,
} from '../../../services/admin/committee-service';
import { doFetch, fetchClear } from '../../../services/fetch/fetch.actions';
import { fetchRole } from '../../../services/politician/profile-service';
import * as userConstants from '../users/functions/constants';

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTable: 0,
      search: '',
      open: false,
      currentPage: 0,
      currentRowPerPage: 10,
      addedCommittee: {},
      openActivate: [],
      openRemove: [],
      elementsSyncDialog: false,
    };
  }

  componentDidMount() {
    const {
      committees: { fetched, fetching, error },
      dispatch,
      me: { fetched: meFetched, fetching: meFetching },
    } = this.props;

    if (!meFetched && !meFetching) {
      dispatch(doFetch(
        'ME',
        fetchRole()
          .then((res) => {
            if (!res.ok) {
              throw res.statusText;
            }
            return res.json();
          }),
      ));
    }
    if (!fetched && !fetching) {
      dispatch(this.loadCommittees());
    }
    if (error === 'Forbidden' || error === 'Unauthorized') {
      window.location = `${window.location.origin}/#/no-access`;
    }
  }

  loadCommittees = () => (dispatch) => {
    dispatch(doFetch(
      'COMMITTEES',
      fetchCommittees()
        .then((res) => {
          if (!res.ok) {
            if (res.status === 403) {
              window.location = `${window.location.origin}/#/no-access`;
            }
            throw res.statusText;
          }
          return res.json();
        }),
    ));
  }

  activateCommittee = (id) => {
    const { dispatch, history } = this.props;
    const { openActivate } = this.state;
    postActivateCommittee(id, true)
      .then((res) => {
        if (!res.ok) { throw res.statusText; }
        this.setState({ openActivate: { ...openActivate, [id]: false } });
        dispatch(fetchClear('COMMITTEES'));
        dispatch(this.loadCommittees());
        history.push('/admin/utvalg');
        return res;
      });
  }

  removeCommittee = (id) => {
    const { dispatch } = this.props;
    postRemoveCommittee(id)
      .then((res) => {
        if (!res.ok) { throw res.statusText; }
        this.setState({ });
        dispatch(fetchClear('COMMITTEES'));
        dispatch(this.loadCommittees());
        return res;
      });
  }

  fetchaddCommitteefunction = (name, esaId, shortCode, index) => {
    const { addedCommittee } = this.state;
    const { dispatch } = this.props;
    putCommittee({
      name,
      esaId,
      shortCode,
      index,
      active: true,
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        this.setState({ addedCommittee: { ...addedCommittee, [name]: 'success' } });
        dispatch(fetchClear('COMMITTEES'));
        dispatch(this.loadCommittees());
      }).catch(() => this.setState({ addedCommittee: { ...addedCommittee, [name]: 'error' } }));

    this.setState({ open: false });
  }


  render() {
    const {
      classes,
      committees: {
        payload: { Resources: data },
        fetching,
        fetched,
        error: fetchError,
      },
      me: { payload: me, fetched: meFetched },
      history,
    } = this.props;
    const {
      selectedTable, search, currentPage, currentRowPerPage,
      addedCommittee, open, openActivate, openRemove, elementsSyncDialog,
    } = this.state;

    const min = currentPage * currentRowPerPage;
    const max = min + currentRowPerPage - 1;

    const filtered = data != null ? data
      .filter(item => (`${item.display.toLowerCase()} ${item.code.toLowerCase()}`)
        .includes(search.toLowerCase()) || search === '') : [];

    const options = [5, 10, 25, 100];
    let paginated = [];
    if (fetched && !fetchError) {
      paginated = filtered.filter(item => (
        item.active ? selectedTable === 0 : selectedTable === 1
      ));
    }

    const list = paginated.filter((item, i) => i <= max && i >= min);

    return (
      <div className={classes.root}>
        <Typography variant="h4" className={classes.mb} color="primary">Utvalg</Typography>
        <div className={classes.flex}>
          <TextField className={classes.search} label="Søk etter utvalg" margin="dense" value={search} onChange={e => this.setState({ search: e.target.value, currentPage: 0 })} />
          <Button variant="outlined" color="primary" onClick={() => {
            this.setState({ elementsSyncDialog: true });
          }} className={classes.button}>
              Synkroniser til Elements
          </Button>
          {meFetched && me.active === userConstants.ENABLED && (
            <Button variant="outlined" color="primary" onClick={() => this.setState({ open: true })} className={classes.button}>
              + Registrer nytt utvalg
            </Button>
          )}
        </div>
        <Tabs
          className={classes.tabs}
          value={selectedTable}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, value) => {
            this.setState({ selectedTable: value });
          }}
        >
          <Tab label="Aktiverte" className={classes.tab} />
          <Tab label="Deaktiverte" className={classes.tab} />
        </Tabs>
        <AddParty
          open={open}
          handleCancel={() => this.setState({ open: false })}
          handleAccept={(name, esaId, shortCode) => {
            this.fetchaddCommitteefunction(name, esaId, shortCode, data ? data.length + 1 : 1);
          }}
          onEnter={() => this.setState({ addedCommittee: {} })}
          committee
        />
        <Dialog
          open={elementsSyncDialog}
          title="Vil du synkronisere utvalgene dine til Elements?"
          text="Synkronisering kan ta noen minutter."
          noTimer
          handleClose={() => this.setState({ elementsSyncDialog: false })}
          handleAccept={() => {
            postSyncElements()
              .then((res) => {
                if (!res.ok) {
                  throw res;
                }
              })
              .catch(() => {
                // eslint-disable-next-line no-console
                console.log('Feil ved synkronisering av elementer');
              });
            this.setState({ elementsSyncDialog: false });
          }}
          agreeButtonSubmitStyle
          agreeButton="Synkroniser"
        />
        
        {!fetchError ? (
          <div>
            <List key={1} component="nav" disablePadding>
              <Divider />
              {list.length > 0 && list
                .map(({
                  name, id, members, active, display, code,
                }, i) => (
                  <div key={`id-${id}`}>
                    {active ? (
                      <MuiListItem key={id} className={clsx(i % 2 !== 0 && classes.odd, classes.listitem)} divider button onClick={() => { history.push(`/admin/utvalg/${id}`); }}>
                        <ListItemText
                          primary={`${display || name} (${code})`}
                          secondary={`Antall medlemmer: ${members != null ? Object.keys(members).length : '0'}`}
                          className={classes.muilistitemtext}
                        />
                      </MuiListItem>
                    ) : [
                      <MuiListItem key={`${id}-2`} className={clsx(i % 2 !== 0 && classes.odd, classes.listitemDeactive)} divider>
                        <ListItemText
                          primary={`${display || name}`}
                          key={4}
                          secondary={`Antall medlemmer: ${members != null ? members.length : '0'}`}
                          className={classes.muilistitemtext}
                        />
                        <Button
                          key={5}
                          variant="contained"
                          color="secondary"
                          className={classes.activate}
                          onClick={() => this.setState({
                            openActivate: { ...openActivate, [id]: true },
                          })}
                        >
                          Aktiver
                        </Button>
                      </MuiListItem>,
                      <Dialog
                        key="Aktiver utvalg"
                        title="Aktiver utvalg"
                        text={`Ønsker du å aktivere ${display || name} på nytt?`}
                        open={!!openActivate[id]}
                        handleClose={() => this.setState({
                          openActivate: { ...openActivate, [id]: false },
                        })}
                        handleAccept={() => this.activateCommittee(id)}
                        agreeButton="Aktiver"
                        removeText={meFetched && me.roles.includes('superadmin') && members && !(members.length !== 0) ? 'Fjern utvalg' : ''}
                        removeClick={() => this.setState({
                          openActivate: { ...openActivate, [id]: false },
                          openRemove: { ...openRemove, [id]: true },
                        })}
                      />,
                      <Dialog
                        key="Fjern utvalg"
                        title="Fjern utvalg"
                        text={`Er du sikker på at du vil fjerne ${display || name} for godt? Historikken til utvalget vil da også bli fjernet.`}
                        open={!!openRemove[id]}
                        handleClose={() => this.setState({
                          openRemove: { ...openRemove, [id]: false },
                        })}
                        handleAccept={() => this.removeCommittee(id)}
                        agreeButton="Fjern"
                      />,
                    ]}
                  </div>
                ))}
              {fetching && Object.keys(Array(5).fill(0))
                .map(val => (
                  <ListItem
                    key={`skel-${val}`}
                    primary={<Skeleton />}
                    secondary={<Skeleton />}
                  />
                ))
              }
              {!fetching && list.length === 0 && (
                <MuiListItem divider>
                  <ListItemText
                    primary="Ingen utvalg i listen"
                    secondary="Prøv å søk noe annet eller se annen liste"
                  />
                </MuiListItem>
              )}
            </List>
            {!fetching && list.length > 0 && [
              <Hidden xsDown key="hiddenxs">
                <TablePagination
                  component="nav"
                  page={currentPage}
                  labelDisplayedRows={({ from, to, count }) => `${from}-${to} av ${count}`}
                  labelRowsPerPage="Utvalg per side"
                  rowsPerPage={currentRowPerPage}
                  rowsPerPageOptions={options}
                  count={filtered.filter(item => (
                    item.active ? selectedTable === 0 : selectedTable === 1
                  )).length}
                  onChangePage={(e, page) => this.setState({ currentPage: page })}
                  onChangeRowsPerPage={e => this.setState({ currentRowPerPage: e.target.value, currentPage: 0 })}
                />
              </Hidden>,
              <Hidden smUp key="hiddensm">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="body1" className={classes.showingtext}>
                      {`Viser side ${currentPage + 1} av ${Math.ceil(filtered.filter(item => (
                        item.active ? selectedTable === 0 : selectedTable === 1
                      )).length / currentRowPerPage)}`}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => this.setState({ currentPage: currentPage - 1 })}
                      disabled={currentPage === 0}
                      fullWidth
                    >
                      Forrige side
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      disabled={(currentPage + 1) >= (filtered.filter(item => (
                        item.active ? selectedTable === 0 : selectedTable === 1
                      )).length) / currentRowPerPage}
                      onClick={() => this.setState({ currentPage: currentPage + 1 })}
                    >
                      Neste side
                    </Button>
                  </Grid>
                </Grid>
              </Hidden>,
            ]}
          </div>
        ) : (
          <NotificationBar message="Feil ved henting av utvalgene" variant="error" />
        )}
        {Object.values(addedCommittee).includes('error') && <NotificationBar message="Feil ved oppretting av utvalg" variant="error" />}
      </div>
    );
  }
}

Overview.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  committees: PropTypes.any.isRequired,
  history: PropTypes.any.isRequired,
  me: PropTypes.object.isRequired,
};

const styles = theme => ({
  mb: {
    marginBottom: '0.5rem',
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'bottom',
    marginBottom: '1rem',
    flexWrap: 'wrap-reverse',
  },
  button: {
    minWidth: '13rem',
    marginTop: '8px', // same as Material Ui TextField
    marginBottom: '4px', // same as Material UI TextField
  },
  search: {
    minWidth: '17rem',
  },
  root: {
    maxWidth: '60rem',
    marginBottom: '4rem',
  },
  tabs: {
    minHeight: '2rem',
  },
  tab: {
    maxHeight: '3rem',
    minHeight: 0,
  },
  muilistitemtext: {
    padding: 0,
  },
  odd: {
    backgroundColor: '#f7f7f7',
  },
  listitem: {
    '&:hover, &:focus': {
      borderLeft: `0.2rem solid ${theme.palette.primary.main}`,
    },
    borderLeft: '0.2rem solid transparent',
    [theme.breakpoints.down('sm')]: {
      padding: '0.6rem',
    },
  },
  showingtext: {
    color: '#808080',
    marginTop: '1rem',
  },
  activate: {
    '&:hover': {
      backgroundColor: '#00953b',
      color: '#fff',
    },
  },
  listitemDeactive: {
    borderLeft: '0.2rem solid transparent',
    [theme.breakpoints.down('sm')]: {
      padding: '0.6rem',
    },
  },
});

const mapStateToProps = ({ committees, me }) => ({ committees, me });

export default connect(mapStateToProps)(withRouter(withStyles(styles)(Overview)));
